// i18n primitive — v1 ships hardcoded es-AR per CLAUDE.md (Q1 = Option D:
// Argentina at v1, multi-market architected from day 1, Brazil ships v1.1).
//
// This module exists so the App boot sequence already has the
// initializeStoreLanguage() hook between connect() and iAmReady() — matching
// the Storydots template's ordering. When v1.1 (pt-BR) lands, swap this for a
// real i18next setup; the call site in App.tsx does not need to change.
//
// What we DO at v1: set the document `lang` attribute to `es-AR` (improves
// browser/screen-reader behavior and search engine handling).
//
// What we DO NOT do at v1: load translation bundles, switch keys, detect
// store language from Nexo. Deferred to v1.1.

const V1_LOCALE = "es-AR" as const;

export async function initializeStoreLanguage(): Promise<void> {
  if (typeof document !== "undefined") {
    document.documentElement.lang = V1_LOCALE;
  }
  // Returning a resolved Promise keeps the call-site signature aligned with
  // the future i18next-backed implementation.
  return Promise.resolve();
}

export const currentLocale = V1_LOCALE;

/**
 * Single accessor for the active locale. Every `Intl.DateTimeFormat(...)` /
 * `Intl.NumberFormat(...)` call site should pass `getLocale()` rather than
 * a hardcoded `"es-AR"` string. When v1.1 plugs in real i18n, only this
 * function needs to return the runtime-selected value.
 */
export function getLocale(): string {
  return currentLocale;
}
